import React from 'react';
import equal from 'fast-deep-equal';

export default class SectionNavigator extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      wasActive: [],
      isActive: null,
    };

    this.refs;
  }

  componentDidMount() {
    this.props.items.map((element, key) => {
      this[`btnRef${key}`] = React.createRef();
    });
    this.btnRefTotal = React.createRef();
    this.btnRefSend = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (!equal(this.props, prevProps)) {
      this.refs[`btnRef${this.props.currentActive}`].setAttribute('wasActive', 'true');
      //console.log(this.props.filledItems);
      this.props.filledItems.forEach((item) => {
        this.refs[`btnRef${item}`].setAttribute('isFilled', 'true');
      });
    }
  }

  render() {
    return (
      <div className='co2calculator__nav'>
        {this.props.items.map((element, key) => (
          <button
            type='button'
            ref={`btnRef${key}`}
            key={key}
            onClick={(e) => {
              e, this.props.setActive(key);
            }}
          >
            <span>{element}</span>
          </button>
        ))}
        <button
          className='notFilling'
          type='button'
          ref={`btnRefTotalPage`}
          onClick={(e) => {
            e, this.props.setActive(`TotalPage`);
          }}
        >
          <span>Total</span>
        </button>
        <button
          className='notFilling'
          type='button'
          ref={`btnRefSendPage`}
          onClick={(e) => {
            e, this.props.setActive(`SendPage`);
          }}
        >
          <span>My carbon footprint</span>
        </button>
      </div>
    );
  }
}
